import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { changeQueryInput } from 'SearchAllApp/state/search-all-params/search-all-params.actions';
import { getQueryInput } from 'SearchAllApp/state/search-all.selectors';

import { SearchAllRootStore } from 'SearchAllApp/state/interfaces/search-all-store.interface';

/**
 *
 * SearchAllInputComponent.
 *
 * This component is the search box to filter securities with query string.
 */
@Component({ standalone: false, selector: 'ycn-search-all-input', templateUrl: './search-all-input.template.html' })
export class SearchAllInputComponent implements OnInit, OnDestroy {
    query: string = '';

    private searchSubject = new Subject<string>();

    private storeSubscription: Subscription;

    constructor(private readonly store: Store<{ reducers: SearchAllRootStore }>) {
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }

    mapStateToComponent = (state: SearchAllRootStore): void => {
        this.query = getQueryInput(state);
    };

    ngOnInit(): void {
        this.searchSubject.pipe(debounceTime(200)).subscribe((searchValue) => {
            this.changeQueryInput(searchValue);
        });
    }

    ngOnDestroy(): void {
        this.searchSubject.complete();
        this.storeSubscription.unsubscribe();
    }

    queryChange(): void {
        this.searchSubject.next(this.query);
    }

    clearInput(): void {
        this.query = '';
        this.changeQueryInput(this.query);
    }

    /**
     * Dispatches `changeQueryInput` to set the new `queryInput` value
     * @param queryInput: Query string.
     */
    changeQueryInput(queryInput: string): void {
        this.store.dispatch(changeQueryInput({ queryInput }));
    }
}
